import React from 'react';
import {Provider} from "components/template/TemplateContext";
import {TemplateList} from "components/template/TemplateList";

export const Templates = () => {

    return (
        <Provider>
            <TemplateList/>
        </Provider>
    );
}
